import {Message} from 'iview';
import store from '../index'
var webSocketHost = process.uniEnv.WS_HOST;
import { GetAllNoRedNum,GetMessageCount } from "@/api/chat.js";
import request from "@/utils/chat.js";
var chat_self = '_user'

const state = () => ({
  ws: '',
  chatNum: 0,
  styleNum:0,
  messageNum:0,
  visitorNum:0,
  message: null,
  isShowChat: false,
  chat_uuids:null,
  re_call_chat_uuid:'',
  timer:null
})

const getters = {
  chatNum: (state) => state.chatNum,
  styleNum: (state) => state.styleNum,
  messageNum: (state) => state.messageNum,
  visitorNum: (state) => state.visitorNum,
  totalNum: (state) => {
    return state.chatNum + state.messageNum + state.styleNum + state.visitorNum
  }
}
const mutations = {
  setChatShow(state, isShow) {
    state.isShowChat = isShow
  },
  setChatNumReduce(state, num) {
    state.chatNum =  state.chatNum - num
  },
  setStyleNumReduce(state, num) {
    state.styleNum =  state.styleNum - num
  },
  setMessageNull(state) {
    state.message = null
  },
  init(state) {
    if (state.wx) {
      state.wx.close()
    }

    let that = this
    if (process.env.NODE_ENV == 'development') {
      state.ws = new WebSocket('ws://' + webSocketHost)
    } else {
      state.ws = new WebSocket('wss://' + webSocketHost)
    }
    state.ws.onopen = function () {
      console.log('连接成功')
      state.timer = setInterval(function() {
        state.ws.send({type: "ping"})
      }, 50000);

    }
    state.ws.onerror = function () {
      console.log('web断开失败')
      clearInterval(state.timer);
    }
    state.ws.onclose = function () {
      console.log('关闭')
      clearInterval(state.timer);
    }
    state.ws.onmessage = function (msg) {
      console.log(msg,"msg")
      var data = JSON.parse(msg.data)
      switch (data.type) {
        //初始化,绑定
        case 'init':
          var sendMsg = {
            type: 'bind',
            client_id: data.client_id,
            uid: store.state.userInfo.id + chat_self,
          }
          request.post('bind_uid', sendMsg)
          break
        case 'send':
          state.message = JSON.stringify(data.message)
          if(data.message.design_uuid) {
            state.styleNum++
          } else {
            state.chatNum++
          }
          if (!state.isShowChat) {
            let message = data.message.message
            if (data.message.message_type == 'file') {
              message = '[文件]'
            }
            if (data.message.message_type == 'img') {
              message = '[图片]'
            }
            Message.success('你有新的消息:'+message);
          }
          break
        case 'other_read':
          console.error(123)
          state.chat_uuids = JSON.stringify(data.chat_uuids)
          break
        case 'reCall':
            state.re_call_chat_uuid = data.chat_uuid
            console.error(data.chat_uuid)
            break
      }
    }
  },
  close(state) {
    state.wx.close()
  },
}
const actions = {
  webSocketInit({ commit }) {
    commit('init')
  },
  async getMessage({ commit, state }) {
    let { data } = await GetAllNoRedNum();
    state.chatNum = data.chatNum
    state.styleNum = data.styleNum
    state.visitorNum = data.visitorNum || 0;
    let message = await GetMessageCount()
    state.messageNum =message.data.all;
  },
}
export default { state, getters, mutations, actions,namespaced: true, }
